// assets/keuzehulp-config.js
// Pure quiz-datamodel + resolver (code-gedreven, geen metaobjects). Boom v2: hub 3-way (sets/bags/pro).
// Node (tests): CommonJS. Browser: window.KH_CONFIG (plain defer-script, scoreboard-patroon).
const QUIZ = {
  flows: {
    sets: {
      start: 'sets_type',
      steps: {
        sets_type: { key: 'sets_type', answers: [
          { id: 'ready', next: 'sets_use' }, { id: 'custom', next: 'custom_use' } ] },
        // Kant-en-klaar: gebruik → budget (12 uitkomsten)
        sets_use: { key: 'sets_use', answers: [
          { id: 'familie', next: 'sets_budget_fam' }, { id: 'cadeau', next: 'sets_budget_cad' },
          { id: 'serieus', next: 'sets_budget_ser' }, { id: 'evenement', next: 'sets_budget_eve' } ] },
        sets_budget_fam: { key: 'sets_budget', answers: [
          { id: 'instap', outcome: 'set_familie_instap' }, { id: 'midden', outcome: 'set_familie_midden' }, { id: 'premium', outcome: 'set_familie_premium' } ] },
        sets_budget_cad: { key: 'sets_budget', answers: [
          { id: 'instap', outcome: 'set_cadeau_instap' }, { id: 'midden', outcome: 'set_cadeau_midden' }, { id: 'premium', outcome: 'set_cadeau_premium' } ] },
        sets_budget_ser: { key: 'sets_budget', answers: [
          { id: 'instap', outcome: 'set_serieus_instap' }, { id: 'midden', outcome: 'set_serieus_midden' }, { id: 'premium', outcome: 'set_serieus_premium' } ] },
        sets_budget_eve: { key: 'sets_budget', answers: [
          { id: 'instap', outcome: 'set_evenement_instap' }, { id: 'midden', outcome: 'set_evenement_midden' }, { id: 'premium', outcome: 'set_evenement_premium' } ] },
        // Eigen ontwerp: gebruik → budget (custom uitkomsten)
        custom_use: { key: 'custom_use', answers: [
          { id: 'feestje', next: 'custom_budget_feestje' }, { id: 'kinderen', next: 'custom_budget_kinderen' },
          { id: 'tuin', next: 'custom_budget_tuin' }, { id: 'club', outcome: 'custom_comp' } ] },
        custom_budget_feestje: { key: 'custom_budget', answers: [
          { id: 'instap', outcome: 'custom_mini_feestje' }, { id: 'midden', outcome: 'custom_mini_feestje_premium' } ] },
        custom_budget_kinderen: { key: 'custom_budget', answers: [
          { id: 'instap', outcome: 'custom_kids' }, { id: 'midden', outcome: 'custom_kids_premium' } ] },
        custom_budget_tuin: { key: 'custom_budget', answers: [
          { id: 'instap', outcome: 'custom_starting' }, { id: 'midden', outcome: 'custom_120_12' }, { id: 'premium', outcome: 'custom_120_15' } ] }
      },
      outcomes: {
        set_familie_instap: { id: 'set_familie_instap' }, set_familie_midden: { id: 'set_familie_midden' }, set_familie_premium: { id: 'set_familie_premium' },
        set_cadeau_instap: { id: 'set_cadeau_instap' }, set_cadeau_midden: { id: 'set_cadeau_midden' }, set_cadeau_premium: { id: 'set_cadeau_premium' },
        set_serieus_instap: { id: 'set_serieus_instap' }, set_serieus_midden: { id: 'set_serieus_midden' }, set_serieus_premium: { id: 'set_serieus_premium' },
        set_evenement_instap: { id: 'set_evenement_instap' }, set_evenement_midden: { id: 'set_evenement_midden' }, set_evenement_premium: { id: 'set_evenement_premium' },
        custom_mini_feestje: { id: 'custom_mini_feestje' }, custom_mini_feestje_premium: { id: 'custom_mini_feestje_premium' },
        custom_kids: { id: 'custom_kids' }, custom_kids_premium: { id: 'custom_kids_premium' },
        custom_starting: { id: 'custom_starting' }, custom_120_12: { id: 'custom_120_12' }, custom_120_15: { id: 'custom_120_15' }, custom_comp: { id: 'custom_comp' }
      }
    },
    bags: {
      start: 'bags_serious',
      steps: {
        bags_serious: { key: 'bags_serious', answers: [
          { id: 'fun', next: 'bags_fun_pref' }, { id: 'improve', next: 'bags_imp_pref' } ] },
        bags_fun_pref: { key: 'bags_fun_pref', answers: [
          { id: 'low', outcome: 'bags_fun_low' }, { id: 'twee', next: 'bags_fun_fill' } ] },
        bags_fun_fill: { key: 'bags_fun_fill', answers: [
          { id: 'dontcare', outcome: 'bags_fun_mid' }, { id: 'firmer', outcome: 'bags_fun_premium' } ] },
        bags_imp_pref: { key: 'bags_imp_pref', answers: [
          { id: 'low', outcome: 'bags_imp_low' }, { id: 'official', outcome: 'bags_imp_mid' } ] }
      },
      outcomes: {
        bags_fun_low: { id: 'bags_fun_low' }, bags_fun_mid: { id: 'bags_fun_mid' }, bags_fun_premium: { id: 'bags_fun_premium' },
        bags_imp_low: { id: 'bags_imp_low' }, bags_imp_mid: { id: 'bags_imp_mid' }
      }
    },
    pro: {
      start: 'pro_worp',
      steps: {
        // Worp-type: filtert client-side (tag); vertakt de boom niet.
        pro_worp: { key: 'pro_worp', answers: [
          { id: 'high_flat', next: 'pro_carpet' }, { id: 'high_cutroll', next: 'pro_carpet' },
          { id: 'midlow_flat', next: 'pro_carpet' }, { id: 'midlow_cutroll', next: 'pro_carpet' } ] },
        // Carpet: bepaalt de collectie-pool.
        pro_carpet: { key: 'pro_carpet', answers: [
          { id: 'carpet', outcome: 'bags_pro_carpet' }, { id: 'dontcare', outcome: 'bags_pro' } ] }
      },
      outcomes: {
        bags_pro_carpet: { id: 'bags_pro_carpet' }, bags_pro: { id: 'bags_pro' }
      }
    }
  }
};

function nextStep(flowId, stepId, answerId) {
  const flow = QUIZ.flows[flowId];
  const step = flow && flow.steps[stepId];
  if (!step) return null;
  const ans = step.answers.find(function (a) { return a.id === answerId; });
  if (!ans) return null;
  if (ans.outcome) return { outcome: ans.outcome };
  if (ans.next) return { step: ans.next };
  return null;
}

function resolveOutcome(flowId, answers) {
  const flow = QUIZ.flows[flowId];
  if (!flow) return null;
  let stepId = flow.start;
  for (const a of answers) {
    const res = nextStep(flowId, stepId, a.answer);
    if (!res) return null;
    if (res.outcome) return flow.outcomes[res.outcome] || null;
    stepId = res.step;
  }
  return null;
}

if (typeof module !== 'undefined' && module.exports) { module.exports = { QUIZ, resolveOutcome, nextStep }; }
if (typeof window !== 'undefined') { window.KH_CONFIG = { QUIZ: QUIZ, resolveOutcome: resolveOutcome, nextStep: nextStep }; }
